import { ApolloClient, gql } from '@apollo/client';
import { getDocumentById } from '../../api/queries_v2';

type ResponsePayloadType = {
  id: string | number;
  additionalMessage?: string;
};

type ShareDocumentByEmailProps = {
  documentId: string | number | null;
  additionalMessage?: string | null;
  toEmail: string;
  ccEmails?: string[];
  subject: string;
  includeAttachments: boolean;
  documentType?: 'pdf' | 'docx';
  mergeAttachments?: boolean;
  selectedAttachmentIds?: string[];
};

export const shareDocumentByEmail =
  ({
    documentId,
    additionalMessage,
    toEmail,
    ccEmails,
    subject,
    includeAttachments,
    documentType = 'pdf',
    mergeAttachments = true,
    selectedAttachmentIds,
  }: ShareDocumentByEmailProps) =>
  (client: ApolloClient<object>): Promise<ResponsePayloadType> => {
    const variables = {
      documentId,
      additionalMessage,
      to: toEmail,
      cc: ccEmails,
      subject,
      confirm: true,
      includeAttachments,
      documentType,
      mergeAttachments,
      selectedAttachmentIds,
    };

    const mutation = gql`
      mutation shareDocumentByEmail(
        $documentId: ID!
        $additionalMessage: String
        $cc: [String!]
        $to: String!
        $subject: String!
        $confirm: Boolean
        $includeAttachments: Boolean
        $documentType: String
        $mergeAttachments: Boolean
        $selectedAttachmentIds: [ID!]
      ) {
        shareDocumentByEmail(
          documentId: $documentId
          additionalMessage: $additionalMessage
          cc: $cc
          to: $to
          subject: $subject
          confirm: $confirm
          includeAttachments: $includeAttachments
          documentType: $documentType
          mergeAttachments: $mergeAttachments
          selectedAttachmentIds: $selectedAttachmentIds
        ) {
          success
        }
      }
    `;

    const refetchQueries = [
      {
        query: getDocumentById,
        variables: {
          documentId,
        },
      },
    ];

    return client.mutate({ mutation, variables, refetchQueries }).then(({ data }: Record<any, any>) => {
      return data.shareDocumentByEmail;
    });
  };
